import { observer } from 'mobx-react'
import React, { FC } from 'react'

import { HorizontalAlignment, useIsTabletOrMobile } from '@avantstay/backoffice-core'

import { DatePickerBasedFilter } from '@new/__global/components/Filters/FiltersVariations/DatePicker'
import { FilterRenderingComponentProps } from '@new/__global/components/FiltersFramework'
import { filtersLabels } from '@new/domains/bookings/screens/bookingsList/utils/labels'
import { AvailableDatesRange } from '@new/domains/fastBookingsTapeChart/__types'
import { formatDateRange, parseDateRange } from '@new/domains/fastBookingsTapeChart/__utils'

const _CheckInDatesFilter: FC<FilterRenderingComponentProps<AvailableDatesRange>> = ({
  activeValue,
  label,
  onChange,
  isAccordionOpen,
  isSidebarFilter,
}) => {
  const isTabletOrMobile = useIsTabletOrMobile()

  const getDateRangeObject = (value?: string): AvailableDatesRange | undefined => {
    const parsedRange = value ? parseDateRange(value) : undefined

    if (!parsedRange) {
      return undefined
    }

    return {
      ...parsedRange,
    }
  }

  const handleRangeChange = (value?: string) => {
    onChange(getDateRangeObject(value))
  }

  return (
    <DatePickerBasedFilter
      clearButtonLabel={isTabletOrMobile ? 'Reset' : 'Clear'}
      horizontalAlignment={isTabletOrMobile ? HorizontalAlignment.Right : HorizontalAlignment.Left}
      initialValue={activeValue ? formatDateRange(activeValue) : undefined}
      inputWidthMaxContent
      isAccordionOpen={isAccordionOpen}
      isSidebarFilter={isSidebarFilter}
      labelInternal={label}
      minRangeLength={0}
      onChange={handleRangeChange}
      placeholder="Any date"
      shouldAcceptEmptyDate
      title={filtersLabels.checkIn}
    />
  )
}

export const CheckInDatesFilter = observer(_CheckInDatesFilter)
